
































































import VueOptions from '@utils/VueOptions'
import PricingModel from '@services/PricingModel'

settings =
  name: 'ActivationPlanDisplay'

  resources:
    cart:
      resourceName: 'shopping_cart'
      slug: 'campaigns/:campaignId/shopping_cart'
      fetch: false

  vue:
    props: ['item', 'activationPlan', 'actions', 'options']

    computed:
      lineItem: -> @options?.lineItem

      isRange: -> !@lineItem
      segment: -> @item.segment || @options?.segment || @selectedSegment || @lineItem.segment
      segmentsList: -> @options?.segmentsList || []
      displaySegmentsList: -> @segmentsList.length > 1

      selectedSegment:
        get: -> @$route.query.segment
        set: (segment) -> @$router.replace { query: { ...@$route.query, segment } }

      canRequestMoreInfo: ->
        return false

      dates: ->
        return '' unless @activationPlan?.available_dates?.length
        startDate = dayjs(@activationPlan.available_dates[0].starts_on)
        endDate = dayjs(@activationPlan.available_dates[@activationPlan.available_dates.length - 1].starts_on)
        return startDate.format('MM/DD/YYYY') if startDate.isSame(endDate)
        "#{startDate.format('MM/DD/YYYY')} - #{endDate.format('MM/DD/YYYY')}"

    methods:
      formatMinMax: (min, max) ->
        values = [min, max].filter(Number)
        return '0' unless values.length > 0
        [...new Set(values)].map(@$options.filters.formatNumberShort).join(' - ')

      formatAddon: (addonKey, lineItem) ->
        switch addonKey
          when 'addon_promo_distribution' then 'Addon Promo'

        if lineItem.item.pricing_model is 'omnichannel'
          @$options.filters.formatOmnichannelType addonKey.replace('addon_', '')
        else
          @$options.filters.formatTitle addonKey

export default VueOptions.vue settings
